module.exports = __webpack_public_path__ + "static/media/arrow-ios-downward-fill.e53ffb30.svg";